module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE0AAABeCAMAAABRlWm3AAAAGFBMVEVMaXFXa5VYa5VZbZb////b4OmrtsqCkrGDQr5PAAAAA3RSTlMAULCLrCoGAAAA6UlEQVR42u3ZUQuDMAwEYG2Xu///jydjg817GPTCiCP3qPCRgLapbp3OlbOPmZAxHtiYWdmPymZahpRmFjcTM1prrbXfabdT4ghoaoLC0xSkpalnacrR0TSwNOUcTUNLU25N4xEg4qTFova8xJMHQ1MvPO3IBwdXoxTnaBPvnKNpr7A1SKuONrM0bbWaBrmVpcHWWFibV+m08BPCwm9WsTUESaulNsrUfaHMnqXbMz0NMojkzSFc1UhzRvqWYKbGsnMvqp4XouY5KyDWmhYR6HN9a639gbYnf4veMhvN/Oz++sGQkX3rrOYOVJNOlKAcO3kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/projects/droplet/project-logo.png
// module id = 46
// module chunks = 0